import  { forwardRef, useImperativeHandle , useState, useEffect } from 'react';
import Select from '../../CommonComponent/ReactSelect';
import DatePicker from 'react-datepicker';
import compair from '../../CommonComponent/SortDropDown';
import InputMask from '../../CommonComponent/NumberFormat';
import * as ConstantOptions from '../../Utils/ConstantOptions';
import isEmptyValidation from '../../Validation/EmptyError';
import { ToastMessageNotification } from '../../CommonComponent/ToastNotification';
import {CommonConstant} from '../../Utils/CommonConstant';

let toastMessages = CommonConstant.toastMessages
let constantOptions = ConstantOptions.DROPDOWN_OPTIONS

const BasicInfoTab = forwardRef((props,ref) =>{

    let setBasicInfoData= props.setBasicInfoData;

    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [lastName, setLastName] = useState("");
    const [suffix, setSuffix] = useState();
    const [gender, setGender] = useState();
    const [dob, setDOB] = useState("");
    const [ssn, setSSN] = useState("");
    const [race, setRace] = useState([]);
    const [species, setSpecies] = useState();
    const [ethnicity, setEthnicity] = useState([]);
    const [childProofCaps,setChildProofCaps] = useState();
    const [knownAllergies,setKnownAllergies] = useState();
    const [medicareBeneficaryIdentifier, setmedicareBeneficaryIdentifier] = useState("");
    
    const [firstNameIsEmpty, setFirstNameIsEmpty] = useState(false);
    const [lastNameIsEmpty, setLastNameIsEmpty] = useState(false);
    const [dobIsEmpty, setDOBIsEmpty] = useState(false);
    const [genderIsEmpty, setGenderIsEmpty] = useState(false);
    const [ssnIsNotValid, setSSNIsNotValid] = useState(false);
    const [childProofCapsIsEmpty, setChildProofCapsIsEmpty] = useState(false);
    const [knownAllergiesIsEmpty, setKnownAllergiesIsEmpty] = useState(false);
    const [medicareBeneficaryIdentifierIsNotValid, setmedicareBeneficaryIdentifierIsNotValid] = useState("");
    const [licenceValue, setLicenceValue] = useState("");
    
    useEffect(()=>{
        setBasicInfoData({
        "firstName":firstName,"middleName":middleName,"lastName":lastName,
        "suffix":suffix,"gender":gender,"dob":dob,"ssn":ssn,"race":race,"species":species,
        "ethnicity":ethnicity,"medicareBeneficaryIdentifier":medicareBeneficaryIdentifier,
        "childProofCaps":childProofCaps,"knownAllergies":knownAllergies,"licenceValue":licenceValue
        });
    },[firstName,middleName,lastName,suffix,gender,dob,ssn,race,species,ethnicity,licenceValue,
        medicareBeneficaryIdentifier,childProofCaps,knownAllergies,setBasicInfoData
    ]);

    useImperativeHandle(ref, () => ({

        validateBasicInfo() {

        let isValid = true;
        // var mbiRegex = /[1-9][AC-HJKMNP-RT-Yac-hjkmnp-rt-y][AC-HJKMNP-RT-Yac-hjkmnp-rt-y0-9][0-9]-?[AC-HJKMNP-RT-Yac-hjkmnp-rt-y][AC-HJKMNP-RT-Yac-hjkmnp-rt-y0-9][0-9]-?[AC-HJKMNP-RT-Yac-hjkmnp-rt-y]{2}\d{2}\b/;
        var mbiRegex = /\b\d[A-Z]{2}\d-[A-Z]{2}\d-[A-Z]{2}\d{2}\b/gm;

          if (!isBasicInfoValid()) {
                isValid=false;
                window.scrollTo(0, 100);
            }
            
            if(ssn !== "" && ssn !== null && !ssnValidate(ssn))
            {
                ToastMessageNotification(toastMessages.SSN_IS_NOT_VALID);
                setSSNIsNotValid(true); isValid=false;
                window.scrollTo(0, 100);
            }
            
            if(medicareBeneficaryIdentifier !== "" && !mbiRegex.test(medicareBeneficaryIdentifier))
            {
                isValid=false;
                setmedicareBeneficaryIdentifierIsNotValid(true);
                ToastMessageNotification(toastMessages.MEDICARE_BENEFICARY_IDENTIFIER_NOT_VALID);
                window.scrollTo(0, 100);
            }

            return isValid;
        }

      }));

      const ssnValidate = (ssn) => {
        var regex = new RegExp("^(?!219-09-9999|078-05-1120)(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$");
        if (!regex.test(ssn)) {
            return false;
        }
        return true;
    }

      const isBasicInfoValid = () => {
        let isValidBasicInfo = true;

        let isEmptyValidationArray=[
            {"fieldName":firstName,"functionName":setFirstNameIsEmpty}, 
            {"fieldName":gender,"functionName":setGenderIsEmpty},
            {"fieldName":lastName,"functionName":setLastNameIsEmpty}, 
            {"fieldName":dob,"functionName":setDOBIsEmpty},
            {"fieldName":childProofCaps,"functionName":setChildProofCapsIsEmpty},
            {"fieldName":knownAllergies,"functionName":setKnownAllergiesIsEmpty}
        ]
        
        isEmptyValidationArray.forEach(item=>{
            if(!isEmptyValidation(item.fieldName,item.functionName))
            isValidBasicInfo=false 
        });

        return isValidBasicInfo
    }
    
    const firstNameHandleChange = firstName => {
        setFirstName(firstName.target.value); setFirstNameIsEmpty(false);
    }

    const lastNameHandleChange = lastName => {
        setLastName(lastName.target.value); setLastNameIsEmpty(false);
    }

    const dobHandleChange = date => {
        setDOB(date); setDOBIsEmpty(false);
    }

    const licenceValueHandleChange = licenceValue => {
        setLicenceValue(licenceValue.target.value); 
    }

    const suffixHandleChange = suffix => {
        setSuffix(suffix)
    }

    const genderHandleChange = gender => {
        setGender(gender); setGenderIsEmpty(false);
    }

    const ssnHandleChange = e => {
        setSSN(e.target.value); setSSNIsNotValid(false);
    }

    const medicareBeneficaryIdentifierHandleChange = medicareBeneficaryIdentifier => {
        setmedicareBeneficaryIdentifier(medicareBeneficaryIdentifier.target.value);
        setmedicareBeneficaryIdentifierIsNotValid(false);
    }

    const raceHandleChange = race => {
        setRace(race);
    }

    const ethnicityHandleChange = ethnicity => {
        setEthnicity(ethnicity)
    }

    const speciesHandleChange = species => {
        setSpecies(species);
    }

    const childProofCapsHandleChange = childProofCaps =>{
        setChildProofCaps(childProofCaps); setChildProofCapsIsEmpty(false);
    }

    const knownAllergiesHandleChange = knownAllergies => {
        setKnownAllergies(knownAllergies); setKnownAllergiesIsEmpty(false); 
    }

    return (

        <div className="inner-card">
            <div className="card-header">
                Basic Information
                </div>
            <div className="card-inner-body">
                <div className="tds-row">
                    {/* <div className="tds-column">
                        <label htmlFor="prefix">Prefix</label>
                        <Select
                            className={"custom_select_box"}
                            options={constantOptions.prefixOptions.sort(compair)}
                            id={"prefix"}
                            value={prefix}
                            handleChange={prefixHandleChange}
                        />
                    </div> */}

                    <div className="tds-column">
                        <div className={firstNameIsEmpty ? "tds-validation" : ""}>
                            <label htmlFor="fname">First Name*</label>
                            <input type="text" id="fname" name="fname" value={firstName} onChange={firstNameHandleChange} placeholder="First Name" maxLength={15} autoComplete="none"/>
                        </div>
                    </div>
                    <div className="tds-column">
                        <label htmlFor="mname">Middle Name</label>
                        <input type="text" id="mname" name="mname" value={middleName} onChange={(e) => setMiddleName(e.target.value)} placeholder="Middle Name" maxLength={15} autoComplete="none"/>
                    </div>
                    <div className="tds-column">
                        <div className={lastNameIsEmpty ? "tds-validation" : ""}>
                            <label htmlFor="lname">Last Name*</label>
                            <input type="text" id="lname" name="lname" value={lastName} onChange={lastNameHandleChange} placeholder="Last Name" maxLength={15} autoComplete="none"/>
                        </div>
                    </div>
                    <div className="tds-column">
                        <label htmlFor="suffix">Suffix</label>

                        <Select
                            className={"custom_select_box"}
                            options={constantOptions.suffixOptions.sort(compair)}
                            id={"suffix"}
                            value={suffix}
                            handleChange={suffixHandleChange}
                        />
                    </div>
                    <div className="tds-column">
                        <div className={genderIsEmpty ? "tds-validation" : ""}>
                            <label htmlFor="gender">Gender*</label>

                            <Select
                                className={"custom_select_box"}
                                options={constantOptions.genderOptions.sort(compair)}
                                id={"gender"}
                                value={gender}
                                handleChange={genderHandleChange}
                            />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={dobIsEmpty ? "tds-validation" : ""}>
                            <label htmlFor="dob">Date of Birth*</label>
                            <DatePicker
                                maxDate={new Date()}
                                minDate={new Date("01-01-1900")}
                                showMonthDropdown
                                showYearDropdown
                                selected={dob} onChange={dobHandleChange} placeholderText="DOB" />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={ssnIsNotValid ? "tds-validation" : ""}>
                            <label htmlFor="ssn">SSN</label>

                            <InputMask
                                id="ssn"
                                name="ssn"
                                value={ssn}
                                pattern={"ssn"}
                                handleChange={ssnHandleChange}
                                placeholder={"111-11-1111"}
                            />
                        </div>
                    </div>

                    <div className="tds-column">
                        <div className={medicareBeneficaryIdentifierIsNotValid ? "tds-validation" : ""}>
                            <label htmlFor="medicareBeneficaryIdentifier">Medicare Number</label>
                            <input type="text" id="medicareBeneficaryIdentifier" name="medicareBeneficaryIdentifier" value={medicareBeneficaryIdentifier}
                                onInput={e => e.target.value = e.target.value.toUpperCase()} 
                                onChange={medicareBeneficaryIdentifierHandleChange} 
                                placeholder="1AA1-AA1-AA11"
                                autoComplete="none" />
                        </div>
                    </div>

                    <div className="tds-column">
                            <label htmlFor="licenceValue">Drivers License/ID Number</label>
                            <input type="text" id="licenceValue" name="licenceValue" value={licenceValue} onChange={licenceValueHandleChange} placeholder="Drivers License/ID Number" maxLength={50} autoComplete="none"/>
                    </div>

                    <div className="tds-column">
                        <label htmlFor="race">Race</label>
                        <Select
                                className={"custom_select_box"}
                                options={constantOptions.raceOptions.sort(compair)}
                                id={"race"}
                                value={race}
                                handleChange={raceHandleChange}
                            />
                    </div>
                    <div className="tds-column">
                        <label htmlFor="ethnicity">Ethnicity</label>
                        <Select
                                className={"custom_select_box"}
                                options={constantOptions.ethnicityOptions.sort(compair)}
                                id={"ethnicity"}
                                value={ethnicity}
                                handleChange={ethnicityHandleChange}
                            />                                          
                    </div>
                    <div className="tds-column">
                        <label htmlFor="species">Species</label>
                        <Select
                            className={"custom_select_box"}
                            options={constantOptions.speciesOptions.sort(compair)}
                            id={"species"}
                            value={species}
                            handleChange={speciesHandleChange}
                        />
                    </div>
                    <div className="tds-column">
                        <div className={childProofCapsIsEmpty ? "tds-validation" : ""}>
                            <label htmlFor="childProofCaps">Would you like child proof caps?*</label>
                            <Select
                                className={"custom_select_box"}
                                options={constantOptions.yesOrNoOptions}
                                id={"childProofCaps"}
                                value={childProofCaps}
                                handleChange={childProofCapsHandleChange}
                            />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={knownAllergiesIsEmpty ? "tds-validation" : ""}>
                            <label htmlFor="knownAllergies">Do you have any known Allergies?*</label>
                            <Select
                                className={"custom_select_box"}
                                options={constantOptions.yesOrNoOptions}
                                id={"knownAllergies"}
                                value={knownAllergies}
                                handleChange={knownAllergiesHandleChange}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )

});
export default BasicInfoTab